import { DeletedBadge } from '@editor2/components/Badge';
import { type FC } from 'react';

interface Props {
	name: string;
}

const DeletedEntityView: FC<Props> = (props) => {
	const { name } = props;

	return (
		<div>
			{name} <DeletedBadge />
		</div>
	);
};

export default DeletedEntityView;
